import { useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { errMsg } from "../../lib/api";
import { SNAPSHOT, SnapshotNotice } from "../../lib/snapshot";
import { Logo } from "../../components/site/Logo";
import AdminLayout from "../../components/admin/AdminLayout";
import Dashboard from "./Dashboard";
import Registrations from "./Registrations";
import Sponsors from "./Sponsors";
import Invitations from "./Invitations";
import EventSetup from "./EventSetup";
import Content from "./Content";
import Users from "./Users";
import Integrations from "./Integrations";
import SagFees from "./SagFees";
import { Communications, Payments, Reports } from "./ReadLists";
import Virtual from "./VirtualAdmin";

function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/admin" replace />;
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { await login(form.email, form.password); nav("/admin"); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy p-5">
      <form onSubmit={submit} className="w-full max-w-md rounded-lg bg-white p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-6 text-2xl text-navy">Admin sign in</h1>
        <SnapshotNotice className="mt-4" />
        {error && <p role="alert" className="mt-3 rounded bg-red-50 p-3 text-sm text-red-800" data-testid="admin-login-error">{error}</p>}
        <label htmlFor="login-email" className="field-label mt-5">Email</label>
        <input id="login-email" type="email" required autoComplete="username" className="field-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-login-email-input" />
        <label htmlFor="login-password" className="field-label mt-4">Password</label>
        <input id="login-password" type="password" required autoComplete="current-password" className="field-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-login-password-input" />
        <button type="submit" className="btn-primary mt-6 w-full" disabled={busy || SNAPSHOT} data-testid="admin-login-submit-btn">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <p className="p-10" aria-busy="true">Loading…</p>;
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role === "sag_finance" && !window.location.pathname.includes("/admin/sag-fees")) return <Navigate to="/admin/sag-fees" replace />;
  return children;
}

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route element={<Protected><AdminLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="sag-fees" element={<SagFees />} />
        <Route path="registrations" element={<Registrations />} />
        <Route path="payments" element={<Payments />} />
        <Route path="sponsors" element={<Sponsors />} />
        <Route path="invitations" element={<Invitations />} />
        <Route path="virtual" element={<Virtual />} />
        <Route path="communications" element={<Communications />} />
        <Route path="reports" element={<Reports />} />
        <Route path="event" element={<EventSetup />} />
        <Route path="content" element={<Content />} />
        <Route path="users" element={<Users />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}
